import { Portal } from "@material-ui/core";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { onError } from "apollo-link-error";
import { createHttpLink } from "apollo-link-http";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { ApolloProvider } from "react-apollo";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ERRO_ATUALIZACAO_CADASTRAL_PENDENTE } from "../../componentes/AtualizacaoCadastral/atualizacaoCadastralGql";
import { avisarBloqueioAtualizacaoCadastral } from "../../componentes/AtualizacaoCadastral/avisoBloqueio";
import Loading from "../../componentes/Loading/Loading";
import SnackMessage from "../../componentes/SnakBar";
import { notAuthenticated } from "../../redux/actions/loginAction";
import configureStore from "../../redux/configureStore";
import { exibeErroGlobal } from "../../utils/erroGlobalGraphQL";
import convertMessage from "../../utils/mensagemErroUtil";
import IndexRouters from "./indexRoute";
const store = configureStore();

interface State {
  client: any;
  erro: string;
  isOpen: boolean;
  errors: Array<string>;
  openSnackMessage: boolean;
}

interface Props {}

class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      client: null,
      erro: "",
      isOpen: false,
      errors: [],
      openSnackMessage: false,
    };
  }

  closeSnackMessage = () => this.setState({ openSnackMessage: false, errors: [] });

  componentDidMount() {
    const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
      if (graphQLErrors && exibeErroGlobal(operation.operationName)) {
        for (const erro of graphQLErrors) {
          if (erro.message === ERRO_ATUALIZACAO_CADASTRAL_PENDENTE) {
            // Sem alerta: o modal de atualizacao cadastral trata o bloqueio (e e aberto, se ainda nao estiver).
            avisarBloqueioAtualizacaoCadastral();
            continue;
          }
          if (erro.message && erro.message.indexOf("Usuário não logado") !== -1) {
            store.configureStore.dispatch(notAuthenticated());
            this.state.client.cache.reset();
            this.state.client.clearStore();
            configureStore().persistor.flush();
            configureStore().persistor.purge();
          } else {
            const detalhe = erro.message || (erro as any).detailMessage;
            console.error("Erro GraphQL", operation.operationName, detalhe);
            const mensagem = convertMessage(detalhe);
            this.setState((prevState) => ({
              ...prevState,
              openSnackMessage: true,
              errors: prevState.errors.includes(mensagem) ? prevState.errors : [...prevState.errors, mensagem],
            }));
          }
        }
      } else if (networkError) {
        store.configureStore.dispatch({
          type: "HAS_ERROR",
        });
      }
    });

    const link = createHttpLink({
      uri: `${process.env.REACT_APP_HOST}/rest/graphql.gql`,
      credentials: "include",
    });

    const client = new ApolloClient({
      cache: new InMemoryCache(),
      link: errorLink.concat(link),
      queryDeduplication: false,
      resolvers: {},

      defaultOptions: {
        query: {
          errorPolicy: "all",
        },
      },
    });

    this.setState({ client });
  }

  render() {
    if (!this.state.client) {
      return null;
    }
    return (
      <ApolloProvider client={this.state.client}>
        <Provider store={store.configureStore}>
          <PersistGate loading={<Loading />} persistor={store.persistor}>
            <IndexRouters>
              <Portal>
                <React.Fragment>
                  {this.state.errors.map((e) => (
                    <SnackMessage
                      close={this.closeSnackMessage}
                      open={this.state.openSnackMessage}
                      variant="warning"
                      message={e}
                      key={e + Math.random()}
                    />
                  ))}
                </React.Fragment>
              </Portal>
            </IndexRouters>
          </PersistGate>
        </Provider>
      </ApolloProvider>
    );
  }
}

export default React.memo(App);
